//import createCachedSelector from 're-reselect';
//import { createSelector } from 'reselect';
//import * as recordStore from '../recordStore';

const selectIsConnected = state => state.signalRStore.isConnected;

export const selectors = {
    selectIsConnected
}